module.exports = __webpack_public_path__ + "img/ic_bed_sandh_2.4089bef5.png";